export default __webpack_public_path__ + "f1bd4d17ccfa45f904f7b27e97df396e.png";